/**
 * Prefer the server-queued snapshot so fly overlays stay mounted across gameState churn.
 */
export function resolveHandOrderGrantFlyDisplayOrder(grant, hand) {
  if (!grant?.orderInstanceId) {
    throw new Error('resolveHandOrderGrantFlyDisplayOrder: grant.orderInstanceId is required');
  }
  if (grant.orderSnapshot) {
    return grant.orderSnapshot;
  }
  const fromHand = (hand || []).find(
    (order) => order && String(order.instanceId) === String(grant.orderInstanceId)
  );
  return fromHand || null;
}
